import { FC } from 'react';
import styled from '@emotion/styled';
import { FocusTheme } from '@/components/Focus/configs/theme';
import { useAppSelector } from '@/redux/hooks';
import { selectFocusNewScheduleSlice } from '@/redux/selectors/focusNewScheduleSelectors';
import { FocusScheduling } from '@/redux/slices/slice_types';
import RightsRestriction from './RightsRestriction';

type AvailScheduleStatusProps = {
  row: FocusScheduling;
};

const AvailScheduleStatus: FC<AvailScheduleStatusProps> = ({ row }) => {
  const { rightsValidateBySchedulingId } = useAppSelector(selectFocusNewScheduleSlice);
  const rightsValidate = rightsValidateBySchedulingId[row.id];

  const status = row.status === 'confirmed' ? 'submitted' : row.status;

  return (
    <FlexContain>
      <StatusPill status={status}>{status}</StatusPill>
      {rightsValidate && rightsValidate !== 'valid' && <RightsRestriction schedulingId={row.id} />}
    </FlexContain>
  );
};

export default AvailScheduleStatus;

const FlexContain = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

const StatusPill = styled.div<{ status?: string }>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  min-width: 75px;
  height: 32px;
  padding: ${({ theme }) => theme.spacing(1, 1.5)};
  gap: ${({ theme }) => theme.spacing(0.5)};
  border-radius: 25px;
  background: ${({ status, theme }) => {
    const t = theme as FocusTheme;

    if (status === 'complete') return `${t.palette.success.dark}33`;
    if (status === 'draft') return `${t.palette.warning.main}33`;

    return `${t.palette.neutral[10]}1A`;
  }};
  color: ${({ status, theme }) => {
    const t = theme as FocusTheme;

    if (status === 'complete') return t.palette.success.dark;
    if (status === 'draft') return t.palette.warning.main;

    return t.palette.neutral[20];
  }};
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  white-space: nowrap;
  text-transform: capitalize;
`;
